import strings from "../../../../strings";
import OwnerReport from "../../partial/Tabs/Bgv/OwnerReport/OwnerReport";
import emptyUCC from "../../../../styles/images/emptyUCC.svg";
import React from "react";
const bgvString = strings.APPLICANT.BGV

const BackgroundReportOwnerJsx = (props) => {
    const reportData = props.data?.response?.response?.BpsReportResponseEx?.response?.Individual
    return reportData && Object.entries(reportData).length ? (
        <OwnerReport person={reportData} />
    ) : (
        <div className="pb-5">
            <div className='emptyIcon'>
                <img src={emptyUCC} alt="no data icon" />
                <div className="noResultsMessageDiv">
                    <p className="noResultsText boldText">{bgvString.THERE_WERE_NO_RESULTS}</p>
                    <p className="noResultsText">{bgvString.NO_RESULTS_FOR_OWNER}</p>
                </div>
            </div>
        </div>
    )
}

export default BackgroundReportOwnerJsx
